export default {
  CANT_AGREE: "cantAgree",
  DONT_KNOW: "dontKnow",
};
